import SEO from '../components/SEO';
import './Legal.css';

const Terms = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions"
        description="Read the Terms and Conditions for IdeaPetal Games. Understand the rules and guidelines for using our platform."
        keywords="terms and conditions, user agreement, legal terms"
      />
      <div className="legal-page">
        <div className="legal-header">
          <div className="container">
            <h1>Terms & Conditions</h1>
            <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>
          </div>
        </div>

        <div className="legal-content">
          <div className="container">
            <section>
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using IdeaPetal Games ("we", "us", "our"), you accept and agree to be bound by the 
                terms and provision of this agreement. If you do not agree to abide by the above, please do not use 
                this service.
              </p>
            </section>

            <section>
              <h2>2. Use License</h2>
              <p>
                Permission is granted to temporarily access the materials on IdeaPetal Games' website for personal, 
                non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and 
                under this license you may not:
              </p>
              <ul>
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to decompile or reverse engineer any software contained on the website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
              </ul>
            </section>

            <section>
              <h2>3. Disclaimer</h2>
              <p>
                The materials on IdeaPetal Games' website are provided on an 'as is' basis. IdeaPetal Games makes no 
                warranties, expressed or implied, and hereby disclaims and negates all other warranties including, 
                without limitation, implied warranties or conditions of merchantability, fitness for a particular 
                purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section>
              <h2>4. Limitations</h2>
              <p>
                In no event shall IdeaPetal Games or its suppliers be liable for any damages (including, without 
                limitation, damages for loss of data or profit, or due to business interruption) arising out of the 
                use or inability to use the materials on IdeaPetal Games' website, even if IdeaPetal Games or an 
                authorized representative has been notified orally or in writing of the possibility of such damage.
              </p>
            </section>

            <section>
              <h2>5. Accuracy of Materials</h2>
              <p>
                The materials appearing on IdeaPetal Games' website could include technical, typographical, or 
                photographic errors. IdeaPetal Games does not warrant that any of the materials on its website are 
                accurate, complete, or current. IdeaPetal Games may make changes to the materials contained on its 
                website at any time without notice.
              </p>
            </section>

            <section>
              <h2>6. Links</h2>
              <p>
                IdeaPetal Games has not reviewed all of the sites linked to its website and is not responsible for 
                the contents of any such linked site. The inclusion of any link does not imply endorsement by 
                IdeaPetal Games of the site. Use of any such linked website is at the user's own risk.
              </p>
            </section>

            <section>
              <h2>7. Modifications</h2>
              <p>
                IdeaPetal Games may revise these terms of service for its website at any time without notice. By using 
                this website you are agreeing to be bound by the then current version of these terms of service.
              </p>
            </section>

            <section>
              <h2>8. Governing Law</h2>
              <p>
                These terms and conditions are governed by and construed in accordance with applicable laws. Any 
                disputes relating to these terms and conditions will be subject to the exclusive jurisdiction of the 
                courts in the jurisdiction where IdeaPetal Games operates.
              </p>
            </section>

            <section>
              <h2>9. Contact Information</h2>
              <p>
                If you have any questions about these Terms & Conditions, please contact us at{' '}
                <a href="/contact">our contact page</a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
